import * as swcHelpers from '@swc/helpers';
import React__default, { useState } from 'react';
import { useLocalStorage } from '@grandvisionhq/utils';
import { useVto } from '../../context/VtoProvider.js';

function useDittoId(onDeleteCallback) {
    const { config  } = useVto();
    const { accessKey , apiUrl , isEnabled , getSignature  } = config;
    const [shouldSkipDeleteCallback, setSkipDeleteCallback] = useState(false);
    const [dittoId, setDittoId] = useLocalStorage('vto.dittoId', undefined, (value)=>value === undefined
    );
    const deleteDittoId = React__default.useCallback(swcHelpers.asyncToGenerator(function*(skipDeleteCallback = false) {
        setSkipDeleteCallback(skipDeleteCallback);
        if (!isEnabled) {
            return;
        }
        if (dittoId) {
            setDittoId(undefined);
            const url = apiUrl + `/api/1.3/dittos/${dittoId}`;
            const headers = {
                'X-Ditto-Access-Key-Id': accessKey,
                'X-Ditto-Signature': yield getSignature(dittoId)
            };
            yield fetch(url, {
                headers,
                method: 'delete'
            });
        }
    }), [
        dittoId
    ]);
    const idRef = React__default.useRef();
    React__default.useEffect(()=>{
        if (!shouldSkipDeleteCallback && onDeleteCallback && dittoId === undefined && (idRef === null || idRef === void 0 ? void 0 : idRef.current) !== undefined) {
            onDeleteCallback();
        }
        idRef.current = dittoId;
    }, [
        dittoId
    ]);
    return {
        dittoId,
        setDittoId,
        deleteDittoId
    };
}

export { useDittoId };
//# sourceMappingURL=use-ditto-id.js.map
